import cookie from 'js-cookie';

/**
 * 브라우저에서 특정 쿠키 취득
 *
 * @param key - 특정 쿠키의 key
 */
export const getCookie = key => cookie.get(key);
